import { combineReducers, configureStore } from '@reduxjs/toolkit';
import detailedViewReducer from './slices/detailedViewSlice';
import detailsRowsReducer from './slices/detailsRowsSlice';
import apiReducer from './slices/apiSlice';
import budgetSessionReducer from './slices/budgetSessionSlice';

export const RESET_STORE = 'store/reset';

const appReducer = combineReducers({
  detailedView: detailedViewReducer,
  detailsRows: detailsRowsReducer,
  api: apiReducer,
  budgetSession: budgetSessionReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['api/fetchSwimlanes/fulfilled'],
        ignoredPaths: ['api.swimlanes'],
      },
    }),
});

export default store;
